<script>
import * as d3 from 'd3'
import CandelaComponent from '@/components/CandelaComponent'

export default {
  computed: {
    formatted_value() {
      return d3.format(this.format)(this.value)
    }
  },
  extends: CandelaComponent,
  name: 'StatsBox',
  props: {
    bg_color: {type: String, default: () => ''},
    format: {type: String, default: () => ','},
    icon: {type: String, default: () => null},
    text_color: {type: String, default: () => 'white'},
    text_style: {type: String, default: () => 'display-1'},
    value: {default: () => 0}
  }
}
</script>

<template>
<div class='candela-component'>
  <v-card :outlined='true' :class='[bg_color,
    "pa-2 ma-1 d-flex flex-grow-1",
    "justify-space-between align-center"
    ]'>
      <div class='d-flex flex-column'>
        <div class='d-flex justify-space-between'>
          <div :class='[text_style, `${text_color}--text`]'>
            {{formatted_value}}
          </div>
                </div>
        <div :class='[
          `${text_color}--text d-flex align-center`,
            `overline font-weight-bold`
          ]'>{{title}}
        </div>
      </div>
      <candela-icon v-if='icon' :name='icon' :style='{opacity: 0.4}'
        :icon_props='{"large": true}' :class='`${text_color}--text`'/>
  </v-card>
</div>
</template>
